export const OPEN_DATA_NODE = {
    pageName: 'Open Data',
    url: '/OpenData',
    hasChild: false,
    otherSource: false,
    isClicked: true,
};

export function injectOpenDataItem(links) {
    if (!Array.isArray(links) || links.length === 0) return links;
    const next = links.slice();
    const idx = next.findIndex(
        (l) => l && typeof l.pageName === 'string' && /raport/i.test(l.pageName),
    );
    if (idx >= 0) {
        next.splice(idx + 1, 0, OPEN_DATA_NODE);
    } else {
        next.push(OPEN_DATA_NODE);
    }
    return next;
}
